import React from "react";
import { useTranslation } from "react-i18next";
import ApplyFilterButton from "../../component/ApplyFilter";

const PackageListingFilters = ({
  filters,
  vendorOptions,
  dataOptions,
  validityOptions,
  onFilterChange,
  onApplyFilter,
  onClearFilters,
}) => {
  const { t } = useTranslation();

  return (
    <div className="package-listing-filter-panel">
      <select
        value={filters.vendor}
        onChange={(event) => onFilterChange("vendor", event.target.value)}
        className="package-listing-filter-control"
      >
        <option value="">All Vendors</option>
        {vendorOptions.map((vendor) => (
          <option key={vendor} value={vendor}>
            {vendor}
          </option>
        ))}
      </select>
      <select
        value={filters.days}
        onChange={(event) => onFilterChange("days", event.target.value)}
        className="package-listing-filter-control"
      >
        <option value="">All Days</option>
        {validityOptions.map((validity) => (
          <option key={validity} value={validity}>
            {validity} {t("home.part21")}
          </option>
        ))}
      </select>
      <select
        value={filters.data}
        onChange={(event) => onFilterChange("data", event.target.value)}
        className="package-listing-filter-control"
      >
        <option value="">All Data</option>
        {dataOptions.map((data) => (
          <option key={data} value={data}>
            {Number(data) > 0
              ? `${Number(data).toFixed(2)} ${t("home.part22")}`
              : t("home.part33")}
          </option>
        ))}
      </select>
      <ApplyFilterButton onApply={onApplyFilter} />
      <button
        type="button"
        onClick={onClearFilters}
        className="package-listing-clear-filter"
      >
        Clear
      </button>
    </div>
  );
};

export default PackageListingFilters;
